import axios from "axios";

export const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "bv_access_token";

export function getToken() {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setToken(t) {
    try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch {}
}

export const api = axios.create({
    baseURL: `${API_URL}/api`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    // Let axios set Content-Type automatically for FormData (multipart/form-data with boundary)
    if (cfg.data instanceof FormData) {
        delete cfg.headers["Content-Type"];
    }
    return cfg;
});

// Format FastAPI error detail (string | array | object) into a readable string
export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function getErrorMessage(e) {
    const data = e?.response?.data;
    if (data?.error) return data.error;
    return formatApiErrorDetail(data?.detail) || e?.message || "Unknown error";
}
